// extracted by mini-css-extract-plugin
export var bottomBackgroundImageContainer = "SustainabilityJourney-module--bottomBackgroundImageContainer--9BkQ9";
export var bottomBackgroundImage = "SustainabilityJourney-module--bottomBackgroundImage--3ldE-";